import { render, staticRenderFns } from "./NewsHtmlConfig.vue?vue&type=template&id=7fc2e3c3&scoped=true"
import script from "./NewsHtmlConfig.vue?vue&type=script&lang=js"
export * from "./NewsHtmlConfig.vue?vue&type=script&lang=js"
import style0 from "./NewsHtmlConfig.vue?vue&type=style&index=0&id=7fc2e3c3&prod&lang=scss"
import style1 from "./NewsHtmlConfig.vue?vue&type=style&index=1&id=7fc2e3c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc2e3c3",
  null
  
)

export default component.exports